<div class="org-node">
  <!-- Card -->
  <div
    class="org-card"
    [attr.data-member-id]="member.id"
    [class.org-card--nest-target]="dragState.nestTargetId() === member.id">
    <div class="org-card__header">
      <div class="org-card__initials">{{ initials }}</div>
      <div class="org-card__content">
        @if (member.label) {
          <span class="org-card__badge">{{ member.label }}</span>
        }
        <span class="org-card__name">{{ member.companyName }}</span>
      </div>
      <button
        class="org-card__remove"
        [disabled]="isPendingMember(member.id)"
        (click)="confirmRemove()"
        title="Remover do grupo">
        <i class="pi pi-times"></i>
      </button>
    </div>

    @if (member.partners?.length || member.companyCnpj) {
      <div class="org-card__footer">
        @if (member.partners?.length) {
          <p class="org-card__section-label">Sócios</p>
          <ul class="org-card__partners">
            @for (partner of member.partners; track partner) {
              <li>{{ partner }}</li>
            }
          </ul>
        }
        @if (member.companyCnpj) {
          <span class="org-card__cnpj">{{ member.companyCnpj }}</span>
        }
      </div>
    }
  </div>

  <!-- Children -->
  @if (member.children?.length) {
    <div class="org-connector"></div>
    <ul
      class="orgchart__level"
      cdkDropList
      [id]="'children-drop-list-' + member.id"
      [cdkDropListConnectedTo]="connectedDropListIds"
      [cdkDropListEnterPredicate]="acceptOnlyGroupMembers"
      [cdkDropListSortingDisabled]="true"
      [cdkDropListData]="member.children"
      (cdkDropListDropped)="onDropAsChild($event)">
      @for (child of member.children; track child.id) {
        <li
          class="orgchart__item"
          cdkDrag
          [cdkDragData]="child"
          [cdkDragDisabled]="isPendingMember(child.id)"
          (cdkDragMoved)="onChildDragMoved($event)"
          (cdkDragEnded)="onChildDragEnded($event)">
          <ng-template cdkDragPreview>
            <div class="org-card org-card--drag-preview">
              <div class="org-card__header">
                <div class="org-card__initials">
                  {{ child.companyName.slice(0, 2).toUpperCase() }}
                </div>
                <div class="org-card__content">
                  @if (child.label) {
                    <span class="org-card__badge">{{ child.label }}</span>
                  }
                  <span class="org-card__name">{{ child.companyName }}</span>
                </div>
              </div>
            </div>
          </ng-template>
          <app-group-tree-node
            [member]="child"
            [groupId]="groupId"
            [isTenant]="isTenant"
            [connectedDropListIds]="connectedDropListIds"
            [isPendingMember]="isPendingMember"
            (memberMoved)="memberMoved.emit($event)"
            (memberRemoved)="memberRemoved.emit($event)"
            (memberDroppedInLibrary)="memberDroppedInLibrary.emit($event)" />
        </li>
      }
    </ul>
  }
</div>
